<template>
<div>
  <!--面包屑组件 -->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>内容管理</el-breadcrumb-item>
    <el-breadcrumb-item>添加文章</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
    <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="文章名称" prop="article_title">
            <el-input v-model="editForm.article_title"></el-input>
          </el-form-item>
          <el-form-item label="维文名称" prop="article_title_uy">
            <el-input v-model="editForm.article_title_uy"></el-input>
          </el-form-item>
          <el-form-item label="文章封面">
            <el-upload class="avatar-uploader" action="https://arzu.mldqanal.cn/upload" :headers="headerObj" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="文章分类">
            <el-select v-model="editForm.article_cate_id" placeholder="请选择">
              <el-option v-for="item in cateList" :key="item.id" :label="item.article_category_name + ' - ' + item.article_category_name_uy" :value="item.id" style="cate_list">
                <span>{{ item.article_category_name }}</span>
                <span style="float:right;font-family:alkatip basma tom">{{ item.article_category_name_uy }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="文章内容" prop="article_content">
            <quill-editor v-model="editForm.article_content" :options="editorOption"></quill-editor>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="维文内容" prop="article_content_uy">
            <quill-editor v-model="editForm.article_content_uy" class="ql-editor-uy" :options="editorOption_uy"></quill-editor>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :offset="8">
          <el-button type="primary" @click="saveArticle">保存文章</el-button>
          <el-button>重置</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import '../../global.js'
export default {
  data() {
    return {
      editForm: {
        article_title: '',
        article_title_uy: '',
        article_cate_id: '',
        article_image: '',
        article_content: '',
        article_content_uy: ''
      },
      // 上传接口请求头参数
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      imageUrl: '',
      cateList: [],
      editFormRules: {
        article_title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ],
        article_title_uy: [
          { required: true, message: '请输入维文标题', trigger: 'blur' }
        ],
        article_content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' }
        ],
        article_content_uy: [
          { required: true, message: '请输入维文内容', trigger: 'blur' }
        ]
      },
      editorOption: {
        placeholder: '请输入内容',
        theme: 'snow'
      },
      editorOption_uy: {
        placeholder: 'مەزمۇننى كىرگۈزۈڭ ...',
        theme: 'snow'
      }
    }
  },
  created() {
    this.getCateList()
    this.getArticleInfo()
  },
  methods: {
    async getCateList() {
      const {
        data: res
      } = await this.$http.get('category/articleAll')
      if (res.code !== 200) {
        this.$message.error('分类数据获取失败')
      }
      this.cateList = res.data
    },
    async getArticleInfo() {
      const { data: res } = await this.$http.get('article/' + this.$route.query.id)
      if (res.code !== 200) {
        this.$message.error('数据获取失败')
      }
      this.imageUrl = window.base_image_url + res.data.article_image
      this.editForm = res.data
      this.$message.success('数据获取成功')
    },
    handleAvatarSuccess(res, file) {
      // this.uploadForm.imageUrl = URL.createObjectURL(file.raw)
      this.editForm.article_image = res.save_path
      if (res.code !== 200) {
        this.$message.error('图片上传失败')
      }
      this.imageUrl = window.base_image_url + res.save_path
      this.$message.success(res.msg)
    },
    beforeAvatarUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传歌曲海报只能是 JPG|PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传歌曲海报大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },
    saveArticle() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) {
          return this.$message.error('请填写内容')
        }
        if (this.imageUrl === '') {
          return this.$message.error('请上传文章封面')
        }
        if (this.editForm.article_cate_id === '') {
          return this.$message.error('请选择文章分类')
        }
        const { data: res } = await this.$http.put('article', this.editForm)
        if (res.code !== 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success(res.msg)
        this.$router.push('/article')
      })
    },

    editArticle() {
      this.$refs.editFormRef.validate(async valid => {
        if (this.imageUrl === '') {
          return this.$message.error('请上传文章封面')
        }
        if (this.editForm.article_cate_id === '') {
          return this.$message.error('请选择文章分类')
        }
        const { data: res } = await this.$http.post('article', this.editForm)
        if (res.code !== 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success(res.msg)
        this.$router.push('/article')
      })
    }
  }
}
</script>

<style scoped>
.cate_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 10px 0;
  font-family: 'alkatip basma tom';
}

.el-select {
  width: 70%;
}
</style>
